import {
  useMemo,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { getSets, clearSets } from 'store/sets/actions';
import {
  getSets as getSetsSelector,
  getSetsLoadingState,
  getSetsOptions,
} from 'store/sets/selectors';
import {
  getSet as getSetSelector,
} from 'store/set/selectors';
import useDebounce from 'library/hooks/use-debounce';
import { getLabelMap } from 'library/helpers/text';

const useSetList = (skip = true, defaultSnapshot = {}) => {
  const [query, onQueryChange] = useState('');
  const debouncedQuery = useDebounce(query, 300);
  const dispatch = useDispatch();
  const data = useSelector(getSetsSelector);
  const openedSet = useSelector(getSetSelector);
  const isLoading = useSelector(getSetsLoadingState);
  const options = useSelector(getSetsOptions);
  const labelMapSnapshot = useRef(null);

  useEffect(() => {
    if (!skip) {
      dispatch(getSets({ name: debouncedQuery }));
    } else if(skip && data.length) {
      dispatch(clearSets());

      if (debouncedQuery) {
        onQueryChange('');
      }
    }
  }, [debouncedQuery, skip]);

  useEffect(() => {
    if (!skip) {
      dispatch(getSets({ name: debouncedQuery }));
    } else if(skip) {
      dispatch(clearSets());

      if (debouncedQuery) {
        onQueryChange('');
      }
    }
  }, [debouncedQuery, skip]);

  useEffect(() => () => {
    if(data.length) {
      dispatch(clearSets());
    }
  }, []);

  return useMemo(() => {
    const labelMap = getLabelMap([...data, ...(openedSet ? [{ id: openedSet.id, name: openedSet.name }] : [])], {
      ...defaultSnapshot,
      ...labelMapSnapshot.current,
    });

    labelMapSnapshot.current = labelMap;

    return {
      data,
      isLoading,
      options,
      labelMap,
      onQueryChange,
    };
  }, [data, defaultSnapshot, openedSet]);
};

export default useSetList;
